import { lang } from '../../assets/lang'
const instagram_bot_addon = window.xitFlowBuilderData.instagram_addon

export const hours = [
  { key: 1, value: lang.sequence_single_html_hours_min_1 },
  { key: 5, value: lang.sequence_single_html_hours_mins_5 },
  { key: 15, value: lang.sequence_single_html_hours_mins_15 },
  { key: 30, value: lang.sequence_single_html_hours_mins_30 },
  { key: 45, value: lang.sequence_single_html_hours_mins_45 },
  { key: 60, value: lang.sequence_single_html_hours_hour_1 },
  { key: 120, value: lang.sequence_single_html_hours_hours_2 },
  { key: 180, value: lang.sequence_single_html_hours_hours_3 },
  { key: 240, value: lang.sequence_single_html_hours_hours_4 },
  { key: 300, value: lang.sequence_single_html_hours_hours_5 },
  { key: 360, value: lang.sequence_single_html_hours_hours_6 },
  { key: 420, value: lang.sequence_single_html_hours_hours_7 },
  { key: 480, value: lang.sequence_single_html_hours_hours_8 },
  { key: 540, value: lang.sequence_single_html_hours_hours_9 },
  { key: 600, value: lang.sequence_single_html_hours_hours_10 },
  { key: 660, value: lang.sequence_single_html_hours_hours_11 },
  { key: 720, value: lang.sequence_single_html_hours_hours_12 },
  { key: 780, value: lang.sequence_single_html_hours_hours_13 },
  { key: 840, value: lang.sequence_single_html_hours_hours_14 },
  { key: 900, value: lang.sequence_single_html_hours_hours_15 },
  { key: 960, value: lang.sequence_single_html_hours_hours_16 },
  { key: 1020, value: lang.sequence_single_html_hours_hours_17 },
  { key: 1080, value: lang.sequence_single_html_hours_hours_18 },
  { key: 1140, value: lang.sequence_single_html_hours_hours_19 },
  { key: 1200, value: lang.sequence_single_html_hours_hours_20 },
  { key: 1260, value: lang.sequence_single_html_hours_hours_21 },
  { key: 1320, value: lang.sequence_single_html_hours_hours_22 },
  { key: 1380, value: lang.sequence_single_html_hours_hours_23 },
]

const daysFb = [
  { key: 1, value: lang.sequence_single_html_days_day_1 },
  { key: 2, value: lang.sequence_single_html_days_day_2 },
  { key: 3, value: lang.sequence_single_html_days_day_3 },
  { key: 4, value: lang.sequence_single_html_days_day_4 },
  { key: 5, value: lang.sequence_single_html_days_day_5 },
  { key: 6, value: lang.sequence_single_html_days_day_6 },
  { key: 7, value: lang.sequence_single_html_days_day_7 },
  { key: 8, value: lang.sequence_single_html_days_day_8 },
  { key: 9, value: lang.sequence_single_html_days_day_9 },
  { key: 10, value: lang.sequence_single_html_days_day_10 },
  { key: 11, value: lang.sequence_single_html_days_day_11 },
  { key: 12, value: lang.sequence_single_html_days_day_12 },
  { key: 13, value: lang.sequence_single_html_days_day_13 },
  { key: 14, value: lang.sequence_single_html_days_day_14 },
  { key: 15, value: lang.sequence_single_html_days_day_15 },
  { key: 16, value: lang.sequence_single_html_days_day_16 },
  { key: 17, value: lang.sequence_single_html_days_day_17 },
  { key: 18, value: lang.sequence_single_html_days_day_18 },
  { key: 19, value: lang.sequence_single_html_days_day_19 },
  { key: 20, value: lang.sequence_single_html_days_day_20 },
  { key: 21, value: lang.sequence_single_html_days_day_21 },
  { key: 22, value: lang.sequence_single_html_days_day_22 },
  { key: 23, value: lang.sequence_single_html_days_day_23 },
  { key: 24, value: lang.sequence_single_html_days_day_24 },
  { key: 25, value: lang.sequence_single_html_days_day_25 },
  { key: 26, value: lang.sequence_single_html_days_day_26 },
  { key: 27, value: lang.sequence_single_html_days_day_27 },
  { key: 28, value: lang.sequence_single_html_days_day_28 },
  { key: 29, value: lang.sequence_single_html_days_day_29 },
  { key: 30, value: lang.sequence_single_html_days_day_30 },
]

const daysIg = [
  { key: 1, value: lang.sequence_single_html_days_day_1 },
  { key: 2, value: lang.sequence_single_html_days_day_2 },
  { key: 3, value: lang.sequence_single_html_days_day_3 },
  { key: 4, value: lang.sequence_single_html_days_day_4 },
  { key: 5, value: lang.sequence_single_html_days_day_5 },
  { key: 6, value: lang.sequence_single_html_days_day_6 },
  { key: 7, value: lang.sequence_single_html_days_day_7 },
]

export const days = instagram_bot_addon ? daysIg : daysFb;